import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  Input,
  Renderer2,
  ViewChild,
} from '@angular/core';

import { ButtonComponent } from '../../../common/button/button.component';
import { FormFieldComponent } from '../../../forms/form-field/form-field.component';

@Component({
  selector: 'rt-dropdown-header',
  templateUrl: './dropdown-header.component.html',
  styleUrls: ['./dropdown-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-button]': 'button',
    '[class.has-search]': 'search',
    '[class.centered]': 'hasLeftAction',
    '[class.full-width]': 'fullWidth',
    '[class.has-padding-lr-small]': 'hasHorizontalPaddingSmall',
    '[class.color-darkest]': 'darkest',
  },
})
export class DropdownHeaderComponent {
  @ContentChild(ButtonComponent)
  public button: ButtonComponent;
  @ContentChild(FormFieldComponent)
  public search: FormFieldComponent;

  @ViewChild('heading', { read: ElementRef, static: true }) public headingRef: ElementRef;

  @Input() public hasLeftAction: boolean = false;
  @Input() public hasRightAction: boolean = true;
  @Input() public hasDivider: boolean = true;
  @Input() public uppercase: boolean = true;
  @Input() public fullWidth: boolean = true;
  @Input() public hasHorizontalPaddingSmall: boolean = false;
  @Input() public darkest: boolean = false;

  @Input() public set linesLimit(limit: number) {
    this.renderer.setStyle(
      this.headingRef.nativeElement.querySelector('.text-content'),
      '-webkit-line-clamp',
      limit,
    );
  }

  constructor(private renderer: Renderer2) {}
}
